import actions from './actions';

export default {
  name: 'loginOpenId',
  namespaced: true,
  actions,
};



// WEBPACK FOOTER //
// ./src/features/public/login/openid/store/index.js